import React, { lazy, Suspense, useEffect, useState } from 'react';

import { useCalculetteModal } from 'contexts/CalculetteModalContext';

const loadCalculettePrime = () => import('views/calculette/CalculettePrime');

/** Précharge le chunk avant le clic : évite le masque de fallback au premier ouvert. */
export const prefetchCalculettePrime = loadCalculettePrime;

const CalculettePrime = lazy(loadCalculettePrime);

/**
 * Monte le parcours « Simulation & Soumission de dossier » une seule fois, au
 * niveau du layout : hors contexte lead, il n'est plus rattaché à une page.
 */
export const CalculetteModalHost: React.FC = () => {
  const { isOpen, closeCalculette } = useCalculetteModal();
  const [hasBeenOpened, setHasBeenOpened] = useState(false);

  useEffect(() => {
    if (isOpen) setHasBeenOpened(true);
  }, [isOpen]);

  useEffect(() => {
    const prefetch = () => {
      void prefetchCalculettePrime();
    };
    const idleCallback = window.requestIdleCallback;
    if (idleCallback) {
      const id = idleCallback(prefetch);
      return () => window.cancelIdleCallback(id);
    }
    const timeoutId = window.setTimeout(prefetch, 800);
    return () => window.clearTimeout(timeoutId);
  }, []);

  if (!hasBeenOpened) return null;

  return (
    <Suspense fallback={null}>
      <CalculettePrime
        opportunityId={null}
        open={isOpen}
        onClose={closeCalculette}
        onSaved={closeCalculette}
        // Step3 appelle onSubmitDossier dès le passage en phase soumission :
        // fermer ici interromprait le parcours. La fermeture a lieu via
        // onClose / onCloseParcours après succès.
        onSubmitDossier={() => undefined}
      />
    </Suspense>
  );
};

export default CalculetteModalHost;
